import { connect } from 'react-redux';
import { doNotShowAgainChanged } from '../../Modals/redux/actionCreators';
import { CompliantLocalStorageKeys } from '../../redux/compliantLocalStorage/constants';
import { getCompliantLocalStorageItem } from '../../redux/compliantLocalStorage/selectors';
export const mapStateToProps = (state, ownProps)=>{
    const dnsDb = getCompliantLocalStorageItem(state, CompliantLocalStorageKeys.DO_NOT_SHOW_AGAIN);
    let autoAccept = false;
    if (dnsDb) {
        try {
            const dnsItems = JSON.parse(dnsDb);
            autoAccept = dnsItems[ownProps.doNotShowAgainKey || ''];
        } catch (e) {}
    }
    return {
        autoAcceptForDoNotShow: autoAccept
    };
};
export const mapDispatchToProps = (dispatch, props)=>({
        onDoNotShowAgainChange: (key, value)=>dispatch(doNotShowAgainChanged(key, value))
    });
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=ConfirmationModal.container.js.map